import { Auth0Provider } from '@auth0/auth0-react'
import type { PropsWithChildren } from 'react'

import { getAuth0Options } from '../../gateways/auth0'
import { useNavigate } from '../../router/hooks/useNavigate'

export const Auth0ProviderWithNavigate = ({ children }: PropsWithChildren) => {
  const navigate = useNavigate()
  const { domain, clientId, redirectUri, audience } = getAuth0Options()

  const onRedirectCallback = (appState: any) => {
    navigate(appState?.returnTo || window.location.pathname)
  }

  return (
    <Auth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        audience,
        redirect_uri: redirectUri,
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  )
}
